import { render, staticRenderFns } from "./DeadSpecimenEvidence.vue?vue&type=template&id=1f095d94"
import script from "./DeadSpecimenEvidence.vue?vue&type=script&lang=js"
export * from "./DeadSpecimenEvidence.vue?vue&type=script&lang=js"
import style0 from "./DeadSpecimenEvidence.vue?vue&type=style&index=0&id=1f095d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports